export const environment = {
  production: false,
  // API_URL: "https://www.responscity.com/spartan_wapi/api",
   API_URL: "https://api.dev-spartan.responscity.com/api",
  img: "",
  // API_URL: "https://spartanmma.responscity.com/login",
  // API_URL: "http://192.168.27.61:4245/api",
  // API_URL: "http://192.168.27.59:4245/api",
  // API_URL: "https://spartan17-06/api",
};
